import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { Link, Stack, Typography } from "@mui/material";
import { PersonEducation as PersonEducationType } from "../../api/person";
import { ProfileSection } from "./profile-section";

export const PersonEducation = ({
	education,
}: {
	education: PersonEducationType[];
}) => {
	return (
		<ProfileSection title="Education" dataComponent="person-education-paper">
			<Stack spacing={1} data-component="education-list">
				{education?.map((ed) => {
					const hasStart =
						ed.start_year !== null && ed.start_year !== undefined;
					const hasEnd = ed.end_year !== null && ed.end_year !== undefined;
					const yearsText =
						hasStart && hasEnd
							? `${ed.start_year} - ${ed.end_year}`
							: hasStart
								? `${ed.start_year}`
								: hasEnd
									? `${ed.end_year}`
									: "";

					return (
						<Stack key={ed.id} spacing={0} data-component="education-entry">
							<Stack direction="row" alignItems="center" spacing={0.5}>
								<Typography
									variant="body2"
									color="text.primary"
									sx={{ fontWeight: 600 }}
									data-component="school-name"
								>
									{ed.school_name}
								</Typography>
								{ed.linkedin_url && (
									<Link
										sx={{
											display: "inline-flex",
											alignItems: "center",
										}}
										target="_blank"
										href={ed.linkedin_url}
										data-component="school-linkedin-link"
									>
										<LinkedInIcon sx={{ fontSize: 18 }} />
									</Link>
								)}
							</Stack>
							{yearsText && (
								<Typography
									variant="caption"
									color="text.secondary"
									data-component="education-years"
								>
									{yearsText}
								</Typography>
							)}
							{(ed.degree || ed.field) && (
								<Typography
									variant="body2"
									color="text.primary"
									data-component="education-degree"
								>
									{ed.degree}
									{ed.degree && ed.field && " in "}
									{ed.field}
								</Typography>
							)}
						</Stack>
					);
				})}
			</Stack>
		</ProfileSection>
	);
};
